<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.damages'), $t('text.list')]"></breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            v-model.trim="searchForm.serialNo"
            :placeholder="$t('text.serialNo')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            v-model.trim="searchForm.productNo"
            :placeholder="$t('product.productNo')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" custom zoom class="table-toolbar">
          <template v-slot:buttons>
            <span class="pager-total">
              {{ $t("rules.pagerTotal", [pager.total]) }}
            </span>
          </template>
        </vxe-toolbar>
      </sticky>

      <vxe-table
        :data="records"
        @sort-change="sortRecords"
        :sort-config="{ remote: true }"
        :custom-config="{ storage: true, checkMethod: checkColumnMethod }"
        :span-method="mergeMethod"
        :loading="loading"
        id="bargainsTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        highlight-hover-row
        auto-resize
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column field="images" :title="$t('product.images')">
          <template v-slot="{ row }">
            <thumbnail :images="row.images" />
          </template>
        </vxe-table-column>
        <vxe-table-column field="serialNo" :title="$t('text.serialNo')" />
        <vxe-table-column field="productNo" :title="$t('product.productNo')">
          <template v-slot="{ row }">
            {{ row.productNo }}
            <div class="font10">{{ row.color }} {{ row.size }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          width="70"
        />
        <vxe-table-column field="voucher" :title="$t('damage.voucher')">
          <template v-slot="{ row }">
            <thumbnail-text :images="row.voucher" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="type"
          :title="$t('text.workflowState')"
          width="80"
        >
          <template v-slot="{ row }">
            <state-label :state="row.workflowState">
              {{ $t("damageWorkflowStates." + row.workflowState) }}
            </state-label>
          </template>
        </vxe-table-column>
        <vxe-table-column field="shopName" :title="$t('menu.warehouses')">
          <template v-slot="{ row }">
            {{ row.shopName }}
            <div class="font10">{{ row.shelfName }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="ownerName"
          :title="$t('text.owner')"
        ></vxe-table-column>

        <vxe-table-column field="remark" :title="$t('text.remark')">
          <template v-slot="{ row }">
            <raw-html-limit-number :content="row.remark" :number="20" />
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="verifyBy"
          :title="$t('damage.verifyInfo')"
          width="160"
        >
          <template v-slot="{ row }">
            <span v-if="['agreed', 'outed'].includes(row.workflowState)">
              {{ row.verifyBy }}
              <div class="font10">{{ row.verifyAt }}</div>
            </span>
            <span v-else>
              {{ row.rejecterName }}
              <div class="font10">{{ row.rejectAt }}</div>
              <raw-html-limit-number :content="row.rejectReason" :number="20" />
            </span>
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="createAt"
          :title="$t('text.createAt')"
          width="110"
        />
        <vxe-table-column
          field="action"
          :title="$t('text.action')"
          width="90"
          fixed="right"
        >
          <template v-slot="{ row, rowIndex }">
            <span
              v-if="
                Permit.wmsManageShopIds().includes(row.applyDepartId) ||
                Permit.currentUser().admin
              "
            >
              <el-button
                v-if="
                  Permit.canActionsChargeEdition('wmsDamageManage') &&
                  row.workflowState == 'newly'
                "
                type="text"
                size="mini"
                @click="editRow(row, rowIndex)"
                >{{ $t("text.edit") }}</el-button
              >

              <el-button
                v-if="
                  Permit.canActionsChargeEdition('wmsDamageManage') &&
                  row.workflowState == 'newly'
                "
                type="text"
                size="mini"
                @click="deleteRow(row)"
                >{{ $t("text.delete") }}</el-button
              >
              <div
                v-if="
                  Permit.canActionsChargeEdition('wmsDamageVerify') &&
                  row.workflowState == 'newly'
                "
              >
                <el-button
                  type="text"
                  size="mini"
                  @click="verifyAgree(row, rowIndex)"
                  >{{ $t("action.agree") }}</el-button
                >
                <el-button
                  type="text"
                  size="mini"
                  @click="verifyReject(row, rowIndex)"
                  >{{ $t("action.reject") }}</el-button
                >
              </div>
            </span>

            <!-- <el-button
              v-if="row.workflowState == 'agreed'"
              type="text"
              size="mini"
              @click="stockOut(row,rowIndex)"
            >{{ $t('action.stockOut') }}</el-button> -->
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }}</span>
          条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>

    <el-dialog
      :title="$t('text.edit')"
      :close-on-click-modal="false"
      :visible.sync="editDF"
      width="30%"
    >
      <el-form ref="editObjForm" :model="editObj" label-width="80px">
        <el-form-item
          :prop="'quantity'"
          :label="$t('text.quantity')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.quantity')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="editObj.quantity"
            :placeholder="invQuantity"
          />
        </el-form-item>
        <el-form-item :prop="'remark'" :label="$t('damage.remark')">
          <el-input
            size="small"
            v-model.trim="editObj.remark"
            type="textarea"
          />
        </el-form-item>
        <el-form-item :prop="'images'" :label="$t('damage.voucher')">
          <dropzone v-model="editObj.voucher" multiple />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="editDoing"
          size="small"
          @click="editSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 拒绝 -->
    <el-dialog
      :title="$t('action.reject')"
      :close-on-click-modal="false"
      :visible.sync="rejectDF"
      width="30%"
    >
      <el-form ref="rejectForm" :model="rejectObj">
        <el-form-item :prop="'rejectReason'">
          <el-input
            size="small"
            v-model.trim="rejectObj.rejectReason"
            type="textarea"
            :placeholder="$t('damage.rejectReason')"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="rejectDoing"
          size="small"
          @click="rejectSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="rejectDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import Thumbnail from "@/components/Thumbnail";
import ThumbnailText from "@/components/ThumbnailText";

import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import Dropzone from "@/components/Dropzone";
import StateLabel from "@/components/StateLabel";

import Damage from "@/api/damage.js";
import Inventory from "@/api/inventory.js";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    RawHtmlLimitNumber,
    Thumbnail,
    ThumbnailText,
    Dropzone,
    StateLabel,
  },
  data() {
    return {
      Util: Util,
      narrows: [
        [
          {
            label: this.$t("text.workflowState"),
            items: Damage.states.map((t) => {
              return {
                key: t,
                label: this.$t("damageWorkflowStates." + t),
                condition: { workflowState: t },
              };
            }),
          },
        ],
      ],

      searchForm: {
        serialNo: null,
        productNo: null,
      },
      sorter: {
        sortBy: "damages_id",
        sortIndicator: "desc",
      },
      initFilter: null,
      //
      // 编辑
      row: null,
      rowIndex: null,
      editDF: false,
      editObj: { quantity: null, remark: null, vocher: null },
      editDoing: false,
      invQuantity: 0,
      // 拒绝
      rejectDF: false,
      rejectObj: { rejectReason: null },
      rejectDoing: false,
    };
  },

  created() {
    const self = this;
    this.$nextTick(() => {
      // 手动将表格和工具栏进行关联
      this.$refs.recordsTable.connect(this.$refs.recordsToolbar);
    });
    if (JSON.stringify(self.$route.query) !== "{}") {
      self.initFilter = self.$route.query.initFilter;
    }
  },
  methods: {
    // 拒绝
    verifyReject(row, rowIndex) {
      this.row = row;
      this.rowIndex = rowIndex;
      this.rejectObj.rejectReason = null;
      this.rejectDoing = false;
      this.rejectDF = true;
    },
    rejectSubmit() {
      const self = this;
      self.rejectDoing = true;
      Damage.reject(self.row.id, this.rejectObj).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.rejectSuccess"),
            type: "success",
          });
          self.rejectDoing = false;
          self.rejectDF = false;
          self.records[self.rowIndex].workflowState = "rejected";
          self.records[self.rowIndex].verifyBy = self.Permit.currentUser().name;
          self.records[self.rowIndex].verifyAt = Util.formatDate(new Date());
          self.records[self.rowIndex].rejectReason =
            self.rejectObj.rejectReason;
          self.$eventHub.$emit("damageReject");
        } else {
          self.sysError();
        }
      });
    },

    // 审核
    verifyAgree(row, rowIndex) {
      const self = this;
      self.agreeDoing = true;
      Damage.agree(row.id).then(function (res) {
        self.agreeDoing = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.verifySuccess"),
            type: "success",
          });
          self.records[rowIndex].workflowState = "agreed";
          self.records[rowIndex].verifyBy = self.Permit.currentUser().name;
          self.records[rowIndex].verifyAt = Util.formatDate(new Date());
          self.$eventHub.$emit("damageAgree");
        } else {
          self.sysError();
        }
      });
    },
    // 删除
    deleteRow(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        Damage.delete(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.loadData();
            self.$eventHub.$emit("damageDelete");
          } else {
            self.sysError();
          }
        });
      }
    },
    // 编辑
    editRow(row, rowIndex) {
      const self = this;
      self.row = row;
      self.rowIndex = rowIndex;
      self.editObj.quantity = row.quantity;
      self.editObj.remark = row.remark;
      self.editObj.voucher = row.voucher;
      const searchObj = {
        productNo: row.productNo,
        color: row.color,
        size: row.size,
        shopId: row.shopId,
      };
      Inventory.findByProductInfo(searchObj).then(function (res) {
        if (res.data.code === 200) {
          self.invQuantity = res.data.entity.quantity;
          self.quantityBeyondDF = false;
          self.editDF = true;
        } else {
          self.invQuantity = 0;
        }
      });
    },

    editSubmit() {
      const self = this;
      self.$refs.editObjForm.validate((valid) => {
        if (valid) {
          if (!Util.regexQuantity(self.editObj.quantity)) {
            self.$message({
              message: self.$t("rules.regex", [self.$t("text.quantity")]),
              type: "warning",
            });
            return;
          }
          self.editDoing = true;
          Damage.update(self.row.id, self.editObj).then(function (res) {
            self.editDoing = false;
            self.editDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.records[self.rowIndex].quantity = self.editObj.quantity;
              self.records[self.rowIndex].remark = self.editObj.remark;
              self.records[self.rowIndex].vocher = self.editObj.vocher;
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    //-----
    dataProvider(params) {
      return Damage.search(params);
    },
  },
};
</script>
